import React from 'react'

import { CompanyData } from 'modules/accountActivity/domain'

export const CompanyDetailsContext = React.createContext<{
  companyData?: CompanyData
  setCompanyData: React.Dispatch<React.SetStateAction<CompanyData | undefined>>
}>({ setCompanyData: () => {} })
